import {select} from 'redux-saga/effects';
import {AppState} from '../../../../../../state/store';
import {FrameSize} from '../type/FrameSize.interface';
import {TextViewerReadType} from '../type/TextViewerReadType';
import {getTextViewerFontFamily} from './getTextViewerFontFamily';
import {getTextViewerFontSizePercent} from './getTextViewerFontSizePercent';
import {getTextViewerLineHeight} from './getTextViewerLineHeight';
import {getTextViewerMargin} from './getTextViewerMargin';

export function* getTextViewerCoreOption({
  size,
  isMobile,
}: {
  size: FrameSize;
  isMobile: boolean;
}) {
  const {fontSizeNumber, fontType, lineGap, marginLevel, isTwoPageLayout} =
    yield select((state: AppState) => ({
      fontSizeNumber: state.textViewer.settings.fontSize,
      fontType: state.textViewer.settings.fontFamily,
      lineGap: state.textViewer.settings.lineGap,
      marginLevel: state.textViewer.settings.contentMargin,
      isTwoPageLayout:
        isMobile ||
        state.textViewer.settings.readType === TextViewerReadType.Scroll
          ? false
          : state.textViewer.settings.isTwoPageLayout,
    }));

  const fontSizePercent = getTextViewerFontSizePercent(fontSizeNumber);
  const fontFamily = getTextViewerFontFamily(fontType);
  const lineHeight = getTextViewerLineHeight(lineGap);
  const margin = getTextViewerMargin({
    marginLevel,
    width: size.width,
    isMobile,
  });
  const twoPagesGap = isTwoPageLayout
    ? Math.round(window.innerWidth * 0.06)
    : 0;

  return {
    fontSizePercent,
    fontFamily,
    lineHeight,
    margin,
    size,
    isTwoColumnLayout: isTwoPageLayout,
    twoPagesGap,
  };
}
